import React, { useContext } from "react";
import { QuizContext } from "../../App";
import TextMistake from "../text/TextMistake";

const ButtonConfirmQuizTable = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;
  const colorHeaders = quizContext.state.checkHeaders && theme === "dark"
    ? "#03f603"
    : quizContext.state.checkHeaders && theme === "light"
      ? "green"
      : "red";
  const colorVaules = quizContext.state.checkVaules && theme === "dark"
    ? "#03f603"
    : quizContext.state.checkVaules && theme === "light"
      ? "green"
      : "red";
  const colorTitle = quizContext.state.checkQuizTitle && theme === "dark"
    ? "#03f603"
    : quizContext.state.checkQuizTitle && theme === "light"
      ? "green"
      : "red";

  return (
    <>
      <div>
        <span style={{ fontWeight: "600" }}>
          STEP 3:</span> when you fill in the table (<span style={{ color: `${colorHeaders}`, fontWeight: "600" }}>column</span> headers and <span style={{ color: `${colorVaules}`, fontWeight: "600" }}>cell values</span>) and give your quiz a <span style={{ color: `${colorTitle}`, fontWeight: "600" }}>title</span>, confirm it
      </div>
      {quizContext.state.errorMessage === "table mistake"
        && <TextMistake />
      }
      <div style={{ textAlign: "center", marginTop: "5px" }}></div>
      <div style={{
        textAlign: "center",
        marginTop: "5px"
      }}
      >
        {quizContext.state.alertStatus === "changes made"
          ? <button
            className={`${theme}-main-btn`}
            onClick={() => quizContext.dispatch({
              type: "confirmQuizTable"
            })}
          >
            CONFIRM
          </button>
          : <button className={`${theme}-main-btn-inactive`}>
            <span style={{ cursor: "crosshair" }}>
              CONFIRM
            </span>
          </button>
        }
      </div>
    </>
  )
}

export default ButtonConfirmQuizTable